import { memo, SVGProps } from "react";

export const MarkerPin = memo(
  ({
    fill = "#017c6b",
    stroke = "#017c6b",
    strokeWidth = 0,
    ...props
  }: SVGProps<SVGUseElement>) => (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 87 103"
      xmlns="http://www.w3.org/2000/svg"
    >
      <use
        className="map-marker__shape"
        href="#pin-marker-shape"
        fill={fill}
        stroke={stroke}
        strokeWidth={strokeWidth}
        {...props}
      />
    </svg>
  ),
);

export const MarkerCircle = memo(
  ({ fill = "#017c6b", ...props }: SVGProps<SVGUseElement>) => (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <use
        className="map-marker__shape"
        href="#circle-marker-shape"
        fill={fill}
        {...props}
      />
    </svg>
  ),
);

export const MarkerIcon = memo(
  ({
    className,
    fill = "#fff",
    href,
    ...props
  }: {
    className?: string;
  } & SVGProps<SVGUseElement>) => (
    <svg className={className} height="100%" width="100%" viewBox="0 0 32 32">
      <use href={href} fill={fill} {...props} />
    </svg>
  ),
);

export const MarkerBadge = memo(({ iconHref }: { iconHref: string }) => (
  <div className="absolute rounded-full bg-default bottom-0 right-0 h-2/5 w-2/5 flex items-center">
    <MarkerIcon aria-hidden="true" className="scale-[.80]" href={iconHref} />
  </div>
));
